import {
  AfterViewInit,
  Component,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import {
  AdminApi,
  Emoji,
  GameCategory,
  Language,
  Resource,
  ResourceApi,
} from "@lbsdk/*";
import { FuseSplashScreenService } from "@fuse/services/splash-screen.service";
import { environment } from "@env/environment";
import { MatSnackBar } from "@angular/material";
import { GeneralSettingsService } from "@app/main/content/general-settings/general-settings.service";
import * as _ from "lodash";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { HelperService } from "@app/main/core/services/helper.service";
import { getLangNameFromCode } from "language-name-map";
import { Location } from "@angular/common";

@Component({
  selector: "app-general-settings",
  templateUrl: "./general-settings.component.html",
  styleUrls: ["./general-settings.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class GeneralSettingsComponent implements OnInit, AfterViewInit {
  resource: Resource = new Resource();
  resourcersUploadPath: string;
  categories: GameCategory[] = [];
  defaultEmojis: Emoji[] = [];
  languages: any[] = [];
  resources: any[] = [];
  s3BucketUrl: any;
  dialogRef: any;
  private _unsubscribeAll: Subject<any>;
  languageslanguages;
  addLanguages: any[] = [];
  resourceArrays = [
    "gameButtons",
    "words",
    "registrationForm",
    "generalSetting",
    "icons",
    "numbers",
    "ratings",
    "marketplace",
    "messages",
    "profile",
    "rewardPoints",
    "settings",
    "socialLogins",
    "gameOverScreen",
    "splashScreens",
    "splashScreenStyles",
    "sounds",
    "mockImages",
    "backgroundColor",
    "mockPrize",
    "mockGameLogo",
  ];

  message: string = "";

  /**
   *
   * @param adminApi
   * @param fuseSplashScreen
   * @param generalSettingsService
   */
  constructor(
    private adminApi: AdminApi,
    private fuseSplashScreen: FuseSplashScreenService,
    public generalSettingsService: GeneralSettingsService,
    private snackbar: MatSnackBar,
    private _helperService: HelperService,
    private location: Location
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this.generalSettingsService.selectedLanguage = null;

    this.s3BucketUrl = environment.s3BucketUrl;
    // setting grid initial state
    this.resourcersUploadPath =
      environment.mainContainer + "/" + environment.resources;

    this.categories = _.cloneDeep(this.generalSettingsService.categories);
    this.defaultEmojis = _.cloneDeep(this.generalSettingsService.defaultEmojis);
    this.languages = _.cloneDeep(this.generalSettingsService.languages);

    this.addLanguages = this.generalSettingsService.googleSupportedLanguages;

    if (this.generalSettingsService.resources.length !== 0) {
      this.resources = _.cloneDeep(this.generalSettingsService.resources);
    }

    this.generalSettingsService.onCategoriesChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((categories: GameCategory[]) => {
        this.generalSettingsService.allResources.categories = [];
        categories.forEach((category) => {
          this.generalSettingsService.allResources.categories.push({
            title: category.name,
            content: {
              type: "image",
              label: "",
              data: {
                category: category,
                file: {},
                isUpdated: false,
              },
              translation: {
                id: "",
                name: "",
                translationableId: category.id,
                translationableType: "GameCategory",
                adminId: "",
                languageId: "",
                flag: true,
                isUpdated: false,
              },
            },
            isRequired: false,
            isButton: true,
          });
        });
      });

    let data: any = {};

    for (let resource of this.resources) {
      if (!data.resources) data.resources = [];
      // resource.value = environment.s3BucketUrl + resource.value;
      data.resources.push({ resource: resource });
    }
    this.patchingExpansionItemsData(data);
  }

  ngAfterViewInit() {
    this.generalSettingsService.onLanguagesChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((languages) => {
        this.generalSettingsService.allResources.language[2].data = {
          options: languages,
        };
        this.languages = languages;
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /**
   *
   * @param data
   */
  patchingExpansionItemsData(data) {
    if (data.resources && data.resources.length !== 0) {
      data.resources.forEach((el: any, index) => {
        if (el.resource) {
          if (
            el.resource.type === "gameOver" &&
            el.resource.languageId !== null
          ) {
          } else {
            this.checkingResourceAndUpdateUI(el.resource, "resource");
          }
        }
        if (el.translation) {
          this.updatingTranslationIdInUI(el.translation);
        }
      });
    }
    if (data.categories && data.categories.length !== 0) {
      data.categories.forEach((el: any) => {
        if (el.category) {
          this.checkingCategoryAndUpdateUI(el.category, "category");
        }
        if (el.translation) {
          this.updatingTranslationIdInUI(el.translation);
        }
      });
    }
  }

  updatingTranslationIdInUI(translation) {
    if (!translation || !translation.id) return;
    let resourceNames = Object.keys(this.generalSettingsService.allResources);
    resourceNames.forEach((el) => {
      if (Array.isArray(this.generalSettingsService.allResources[el])) {
        this.generalSettingsService.allResources[el].forEach((item: any) => {
          if (
            item.content &&
            item.content.translation &&
            (item.content.translation.translationableId === translation.translationableId ||
              (item.content.data && item.content.data.id === translation.translationableId))
          ) {
            item.content.translation.id = translation.id;
            item.content.translation.name = translation.name;
            item.content.translation.translationableId = translation.translationableId;
            item.content.translation.languageId = translation.languageId;
            item.content.translation.isUpdated = false;
          }
        });
      }
    });
  }

  resetIsUpdatedFlags() {
    this.generalSettingsService.allResources.language[1].content.data.file = {};
    this.generalSettingsService.allResources.language[1].content.data.iconUrl = "";
    this.generalSettingsService.allResources.language[0].content.data.value = "";
    this.generalSettingsService.allResources.language[2].content.data.value = "";

    Object.keys(this.generalSettingsService.allResources).forEach((el: any) => {
      if (Array.isArray(this.generalSettingsService.allResources[el])) {
        this.generalSettingsService.allResources[el].forEach((iterator: any) => {
          if (iterator.content) {
            if (iterator.content.data) {
              iterator.content.data.isUpdated = false;
              if (iterator.content.data.file) {
                iterator.content.data.file = {};
              }
            }
            if (iterator.content.translation) {
              iterator.content.translation.isUpdated = false;
            }
          }
        });
      }
    });
  }

  /**
   *
   * @param data
   * @param type
   */
  checkingCategoryAndUpdateUI(data, type) {
    let index = 0;
    if (type === "category") {
      index = this.generalSettingsService.allResources["categories"].findIndex(
        (el) => el.content.data.category.id === data.id
      );
      if (index !== -1) {
        if (data.name.indexOf("resources/") !== -1) {
          data.name =
            data.name.indexOf("https://") !== -1
              ? data
              : environment.s3BucketUrl + data.name;
          this.generalSettingsService.allResources["categories"][
            index
          ].content.data.category = data;
        } else {
          this.generalSettingsService.allResources["categories"][
            index
          ].content.data.category = data;
        }
      }
    }
  }

  /**
   *
   * @param data
   * @param type
   */
  checkingResourceAndUpdateUI(data, type) {
    let resourcesTitles = Object.keys(
      this.generalSettingsService.allResources
    ).filter((el) => el !== "categories" && el !== "language");

    if (resourcesTitles.length !== 0) {
      resourcesTitles.forEach((el) => {
        let index = 0;
        if (type === "resource") {
          index = this.generalSettingsService.allResources[el].findIndex(
            (allResource) => allResource.content.data.key === data.key
          );
          if (index !== -1) {
            this.generalSettingsService.allResources[el][
              index
            ].content.data.id = data.id;

            this.generalSettingsService.allResources[el][
              index
            ].content.translation.translationableId = data.id;

            if (!_.isUndefined(data.colorMix)) {
              this.generalSettingsService.allResources[el][
                index
              ].content.data.colorMix = {
                flag: true,
                color1: data.colorMix.color1,
                color2: data.colorMix.color2,
                isUpdated: false,
              };
            }
            if (
              data.value !== null &&
              typeof data.value === "string" &&
              data.value.indexOf("resources/") !== -1
            ) {
              this.generalSettingsService.allResources[el][
                index
              ].content.data.value =
                data.value.indexOf("https://") !== -1
                  ? data.value
                  : environment.s3BucketUrl + data.value;
            } else {
              this.generalSettingsService.allResources[el][
                index
              ].content.data.value = data.value;
            }
          }
        }
      });
    }
  }

  /**
   *
   * @param arrName
   * @returns
   */
  filterExpansionItems(arrName: string): any[] {
    return this.generalSettingsService.allResources[arrName].filter(
      (el) =>
        (el.content.type === "input" &&
          (el.content.data.value !== "" || el.content.data.isUpdated)) ||
        ((el.content.type === "image" || el.content.type === "audio") &&
          el.content.data.file !== "" &&
          el.content.data.value !== "" &&
          el.content.data.id === "") ||
        (el.content.data.isUpdated) ||
        (el.content.translation.flag &&
          el.content.translation.isUpdated &&
          el.content.translation.name !== "")
    );
  }

  fetchingResources = async () => {
    let temp = [];
    this.resourceArrays.forEach(arrName => {
      temp = temp.concat(this.filterExpansionItems(arrName));
    });

    return await this.uploadingFileAndGatheringData(temp);
  };

  get isSaveDisabled(): boolean {
    // Check Resources
    for (const arrName of this.resourceArrays) {
      if (this.filterExpansionItems(arrName).length > 0) return false;
    }

    // Check Categories
    const categories = this.generalSettingsService.allResources.categories;
    if (
      categories.some(
        (el) =>
          (el.content.data.file &&
            el.content.data.file.name &&
            el.content.data.isUpdated) ||
          (el.content.translation.flag && el.content.translation.isUpdated) ||
          (el.content.translation.flag &&
            el.content.translation.id === "" &&
            el.content.translation.name !== "")
      )
    )
      return false;

    // Check Language
    if (
      this.generalSettingsService.allResources.language[0].content.data.value !==
      "" ||
      this.generalSettingsService.allResources.language[2].content.data.value !==
      ""
    )
      return false;

    return true;
  }

  /**
   *
   * @param expansionItems
   * @returns
   */
  uploadingFileAndGatheringData = async (expansionItems) => {
    const language =
      this.generalSettingsService.selectedLanguage !== null
        ? this.generalSettingsService.selectedLanguage
        : null;

    let resources = [];
    // working on uploading resource files and compiling in an array
    for (let el of expansionItems) {
      // if (
      //   el.content.data.type === "gameOver" &&
      //   el.content.data.languageId === null &&
      //   (language === null || language === "None")
      // ) {
      //   this.message =
      //     "Please select a language to upload game over resources for that language";
      //   break;
      // } else this.message = "";

      const selectedLangId =
        language && language.id
          ? language.id
          : this.generalSettingsService.selectedLanguage && this.generalSettingsService.selectedLanguage.id
            ? this.generalSettingsService.selectedLanguage.id
            : null;

      el.content.translation.languageId =
        el.content.translation.languageId && el.content.translation.languageId !== ""
          ? el.content.translation.languageId
          : selectedLangId;

      let data: any = {};
      if (
        el.content.data.value !== "" ||
        el.content.data.isUpdated
      ) {
        data.resource = {};
        if (
          el.content.data.key === "automaticDonationMessage" ||
          el.content.data.key === "automaticMessage" ||
          el.content.data.key === "socialLoginPrompt"
        ) {
          let obj = this._helperService.encryptMessage(
            el.content.data.key,
            el.content.data.value,
            el.content.translation.name
          );
          // el.content.data.value = obj.value;
          el.content.translation.name = obj.name;
        }
        data.resource = {
          key: el.content.data.key,
          value: el.content.data.value,
          type: el.content.data.type,
          languageId: el.content.data.languageId
            ? el.content.data.languageId
            : el.content.data.type === "gameOver"
              ? language !== null
                ? language.id
                : null
              : null,
        };

        if (el.content.data.id) data.resource.id = el.content.data.id;

        if (
          el.content.data.file &&
          el.content.data.file.name &&
          (el.content.type === "image" || el.content.type === "audio")
        ) {
          try {
            let response: any = await this.generalSettingsService
              .uploadResource(
                el.content.data.file,
                this.resourcersUploadPath,
                this.adminApi.getCurrentToken().id
              )
              .toPromise();
            if (response) {
              data.resource.value =
                response.result.files["file"][0]["providerResponse"].name;
            }
          } catch (error) {
            alert(error.message);
          }
        } else if (
          (el.content.type === "image" || el.content.type === "audio") &&
          !(el.content.data.file && el.content.data.file.name)
        ) {
          data = {};
        }

        if (el.content.type === "input" && !el.content.data.isUpdated)
          data = {};
      }

      const transableId =
        el.content.translation.translationableId && el.content.translation.translationableId !== ""
          ? el.content.translation.translationableId
          : el.content.data && el.content.data.id
            ? el.content.data.id
            : "";

      if (
        el.content.translation.flag &&
        el.content.translation.isUpdated &&
        el.content.translation.languageId &&
        el.content.translation.languageId !== ""
      ) {
        data.translation = {
          name: el.content.translation.name,
          translationableId: transableId,
          translationableType: el.content.translation.translationableType || "Resource",
          adminId: this.adminApi.getCurrentId(),
          languageId: el.content.translation.languageId,
        };
        if (el.content.translation.id && el.content.translation.id !== "") {
          data.translation.id = el.content.translation.id;
        }
      }

      if (
        (el.content.type === "image" || el.content.type === "audio") &&
        !(el.content.data.file && el.content.data.file.name) &&
        data.translation
      ) {
        data = { translation: data.translation };
      }
      if (!_.isEmpty(data)) {
        resources.push(data);
      }
    }
    return resources;
  };

  fetchingCategories = async () => {
    let categories = [];
    for (let el of this.generalSettingsService.allResources.categories) {
      let data: any = {};
      if (
        el.content.data.file &&
        el.content.data.file.name &&
        el.content.data.isUpdated
      ) {
        data.category = {
          id: el.content.data.category.id ? el.content.data.category.id : "",
          name: el.content.data.category.name,
          image: el.content.data.category.image,
        };
        try {
          let response: any = await this.generalSettingsService
            .uploadResource(
              el.content.data.file,
              this.resourcersUploadPath,
              this.adminApi.getCurrentToken().id
            )
            .toPromise();
          if (response) {
            data.category.image =
              response.result.files["file"][0]["providerResponse"].name;
          }
        } catch (error) {
          alert(error.message);
        }
      }

      if (
        el.content.translation.flag &&
        el.content.translation.id !== "" &&
        el.content.translation.isUpdated
      ) {
        data.translation = {};
        data.translation = {
          id: el.content.translation.id,
          name: el.content.translation.name,
          translationableId: el.content.data.category.id
            ? el.content.data.category.id
            : "",
          translationableType: "GameCategory",
          adminId: this.adminApi.getCurrentId(),
          languageId: el.content.translation.languageId,
        };
      } else if (
        el.content.translation.id === "" &&
        el.content.translation.flag &&
        el.content.translation.name !== ""
      ) {
        data.translation = {};
        data.translation = {
          name: el.content.translation.name,
          translationableId: el.content.data.category.id
            ? el.content.data.category.id
            : "",
          translationableType: "GameCategory",
          adminId: this.adminApi.getCurrentId(),
          languageId: el.content.translation.languageId,
        };
      }
      if (data.category || data.translation) categories.push(data);
    }
    return categories;
  };

  fetchLanguage = async () => {
    let { name, code } =
      this.generalSettingsService.allResources.language[0].content.data;

    const { file } =
      this.generalSettingsService.allResources.language[1].content.data;

    const lang = this.generalSettingsService.allResources.language[2];

    if (
      lang &&
      lang.content &&
      lang.content.data &&
      lang.content.data.value &&
      lang.content.data.value.id
    ) {
      name = lang.content.data.value.name;
      code = lang.content.data.value.code;
    }

    let language: {
      adminId: string;
      name: string;
      code: string;
      dir: string;
      iconUrl?: any;
    } = {
      adminId: this.adminApi.getCurrentId(),
      name,
      code: code,
      dir:
        getLangNameFromCode(code) && getLangNameFromCode(code).dir
          ? getLangNameFromCode(code).dir
          : "ltr",
    };
    if (file && file.name) {
      // if language icon is present only then call upload function
      try {
        let response: any = await this.generalSettingsService
          .uploadResource(
            file,
            this.resourcersUploadPath,
            this.adminApi.getCurrentToken().id
          )
          .toPromise();
        if (response) {
          language.iconUrl =
            response.result.files["file"][0]["providerResponse"].name;
        }
      } catch (error) {
        alert(error.message);
      }
    }
    return language;
  };

  removingTranslationsAndFile() {
    this.generalSettingsService.allResources.language[1].content.data.value =
      "";
    this.generalSettingsService.allResources.language[1].content.data.file = {};
    this.generalSettingsService.allResources.language[1].content.data.iconUrl =
      "";

    this.generalSettingsService.allResources.language[0].content.data.value =
      "";
    this.generalSettingsService.allResources.language[2].content.data.value =
      "";
    Object.keys(this.generalSettingsService.allResources).forEach((el: any) => {
      this.generalSettingsService.allResources[el].forEach((iterator: any) => {
        if (
          iterator.content.type === "image" &&
          iterator.content.data.file &&
          iterator.content.data.file.name
        )
          iterator.content.data.file = {};
        if (iterator.content.translation.flag) {
          iterator.content.translation.name = "";
          // iterator.content.translation.translationableId = '';
          // iterator.content.translation.adminId = '';
          iterator.content.translation.languageId = "";
        }
      });
    });
  }

  /**
   *
   * @returns
   */
  checkingIfTranslationsAreFilled(): boolean {
    return this.getMissingTranslations().length > 0;
  }

  getMissingTranslations(): { section: string; fields: string[] }[] {
    const missing: { section: string; fields: string[] }[] = [];

    this.generalSettingsService.resourceNamesForTranslation.forEach(
      (sectionKey) => {
        const items = this.generalSettingsService.allResources[sectionKey];
        if (Array.isArray(items)) {
          const emptyItems = items.filter(
            (iterator) =>
              iterator.content &&
              iterator.content.translation &&
              iterator.content.translation.flag &&
              (!iterator.content.translation.name ||
                iterator.content.translation.name.trim() === "")
          );

          if (emptyItems.length > 0) {
            const formattedSection = sectionKey
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase())
              .trim();
            const fields = emptyItems.map(
              (item) =>
                item.title ||
                (item.content &&
                  item.content.data &&
                  item.content.data.key) ||
                "Field"
            );
            missing.push({ section: formattedSection, fields });
          }
        }
      }
    );

    return missing;
  }

  onSubmit = async () => {
    // this.fuseSplashScreen.show();
    const missingTranslations = this.getMissingTranslations();
    const missingRequired = this.generalSettingsService.getMissingRequiredFields();

    if (
      (this.generalSettingsService.allResources.language[0].content.data
        .value !== "" ||
        this.generalSettingsService.allResources.language[2].content.data
          .value !== "") &&
      missingTranslations.length > 0
    ) {
      this.fuseSplashScreen.hide();

      const detailMsg = missingTranslations
        .map((item) => `${item.section} (${item.fields.join(", ")})`)
        .join("; ");

      this.snackbar.open(
        `Please fill missing translation(s) in: ${detailMsg}`,
        "CANCEL",
        {
          verticalPosition: "top",
          duration: 7000,
        }
      );
    } else if (missingRequired.length > 0) {
      this.fuseSplashScreen.hide();

      const detailMsg = missingRequired
        .map((item) => `${item.section} (${item.fields.join(", ")})`)
        .join("; ");

      this.snackbar.open(
        `Please fill required field(s) in: ${detailMsg}`,
        "CANCEL",
        {
          verticalPosition: "top",
          duration: 7000,
        }
      );
    } else {
      let data: any = {};
      let resources: any[] = await this.fetchingResources();
      const categories: any[] = await this.fetchingCategories();
      const language: any = await this.fetchLanguage();

      const selectedLanguage =
        this.generalSettingsService.selectedLanguage !== null
          ? this.generalSettingsService.selectedLanguage
          : null;

      if (selectedLanguage !== null) {
        language.id = selectedLanguage.id;
        language.name = selectedLanguage.name;
      }

      resources.forEach((el, index) => {
        if (
          el.resource &&
          el.resource.type === "gameOver" &&
          selectedLanguage == null
        ) {
          resources[index].resource.languageId = null;
        }
      });

      // if colors are added in marketPlace
      this.generalSettingsService.allResources.marketplace.forEach(
        (element) => {
          if (element.content.data.colorMix.isUpdated) {
            let data = _.cloneDeep({
              resource: {
                id: element.content.data.id,
                key: element.content.data.key,
                value: element.content.data.value.replace(
                  environment.s3BucketUrl,
                  ""
                ),
                type: element.content.data.type,
                languageId: element.content.data.languageId
                  ? element.content.data.languageId
                  : element.content.data.type === "gameOver"
                    ? this.generalSettingsService.selectedLanguage.id
                    : null,
                colorMix: element.content.data.colorMix,
              },
            });

            if (data.resource.id === "") delete data.resource.id;
            delete data.resource.colorMix.flag;
            delete data.resource.colorMix.isUpdated;

            let index = resources.findIndex(
              (el) => (el.resource && el.resource.key === element.content.data.key) || el.key === element.content.data.key
            );
            if (index !== -1) {
              resources[index] = data;
            } else {
              resources.push(data);
            }
          }
        }
      );

      // if colors are added in background color
      this.generalSettingsService.allResources.backgroundColor.forEach(
        (element) => {
          if (element.content.data.colorMix.isUpdated) {
            let data = _.cloneDeep({
              resource: {
                id: element.content.data.id,
                key: element.content.data.key,
                value: "",
                type: element.content.data.type,
                languageId: null,
                colorMix: element.content.data.colorMix,
              },
            });

            if (data.resource.id === "") delete data.resource.id;
            delete data.resource.colorMix.flag;
            delete data.resource.colorMix.isUpdated;

            let index = resources.findIndex(
              (el) => (el.resource && el.resource.key === element.content.data.key) || el.key === element.content.data.key
            );
            if (index !== -1) {
              resources[index] = data;
            } else {
              resources.push(data);
            }
          }
        }
      );

      // if colors are added in splashScreenStyles
      this.generalSettingsService.allResources.splashScreenStyles.forEach(
        (element) => {
          if (element.content.data.colorMix && element.content.data.colorMix.isUpdated) {
            let data = _.cloneDeep({
              resource: {
                id: element.content.data.id,
                key: element.content.data.key,
                value: "",
                type: element.content.data.type,
                languageId: null,
                colorMix: element.content.data.colorMix,
              },
            });

            if (data.resource.id === "") delete data.resource.id;
            delete data.resource.colorMix.flag;
            delete data.resource.colorMix.isUpdated;

            let index = resources.findIndex(
              (el) => (el.resource && el.resource.key === element.content.data.key) || el.key === element.content.data.key
            );
            if (index !== -1) {
              resources[index] = data;
            } else {
              resources.push(data);
            }
          }
        }
      );

      if (resources.length !== 0) {
        data.resources = resources;
      }

      if (categories.length !== 0) {
        data.categories = categories;
      }

      if (language.name !== undefined) {
        data.language = language;
      }

      // Note: updatingTranslations was removed because it fetched old DB translations 
      // and attached data.translations, which overwrote data.resources translations in backend.

      if (!_.isEmpty(data)) {
        console.log("data.resources payload:", JSON.stringify(data.resources));
        this.generalSettingsService.saveResources(data).then(
          (response: any) => {
            if (response.resources)
              this.patchingExpansionItemsData(response.resources);

            // TODO: issue needs resolving:- when category translation is updated it got removed from the field
            if (response.categories) {
              response.categories.forEach((iterator) => {
                if (iterator.category) {
                  iterator.category.image =
                    environment.s3BucketUrl + iterator.category.image;
                  let index = this.categories.findIndex(
                    (el) => el.id === iterator.category.id
                  );
                  this.categories[index] = iterator.category;
                }
              });
              this.generalSettingsService.onCategoriesChanged.next(
                this.categories
              );
            }

            if (response.language) {
              this.updateLangugae(response.language);
            }

            this.resetIsUpdatedFlags();

            this.fuseSplashScreen.hide();

            this.snackbar.open("Settings saved successfully!", "CLOSE", {
              verticalPosition: "top",
              duration: 3000,
            });
          },
          (error) => {
            this.snackbar.open(
              error.message,
              `${error.name} ${error.statusCode}`,
              {
                verticalPosition: "top",
                duration: 3000,
              }
            );
            this.fuseSplashScreen.hide();
          }
        );
      } else {
        this.fuseSplashScreen.hide();
        this.message =
          this.message !== ""
            ? this.message
            : `There's nothing to update, Please update any resource and try again!`;
        this.snackbar.open(this.message, "CANCEL", {
          verticalPosition: "top",
          duration: 3000,
        });
      }
    }
  };

  updateLangugae(language) {
    if (!language) return;
    let index = this.languages.findIndex(
      (el) => el.id === language.id && el.name === language.name
    );
    if (index !== -1) {
      this.languages[index] = language;
    } else {
      if (language && language.id) this.languages.push(language);
    }
    this.generalSettingsService.onLanguagesChanged.next(this.languages);
  }

  getImageResource(imgSrc) {
    if (imgSrc) {
      if (imgSrc.indexOf("data:") !== -1) {
        return imgSrc;
      }
      return this.s3BucketUrl + imgSrc.replace(this.s3BucketUrl, "");
    }
  }
}
